import { Card, Group, Title, Grid, Text, Center, Loader, Divider, Button, ScrollArea, Menu, ActionIcon, Container, Space, ThemeIcon, Badge } from "@mantine/core"
import { useParams } from "react-router-dom";
import { IconAdjustmentsHorizontal, IconAlertTriangleFilled, IconArrowUp, IconDots, IconPencil, IconTrash } from "@tabler/icons-react"
import moment from "moment"
import { useRegistrationByIdQuery } from "../../api/programregistration.api";
import { ViewRegistationPageParams } from "../../Pages/Registrations/View";
import { getGender, getAge, formatAddress } from "../../functions/programregistration.functions";
import { AdultParticipant, ChildParticipant, ParticipantBase, ProgramRegistration } from "../../models/programregistration.models";
import ParticipantsListEditor from "./ParticipantListEditor";
import { useProgramRegistrationState } from "../../state/programregistration.state";
import { DataTableColumn } from "mantine-datatable";
import CustomDatatable from "../Shared/CustomDatatable";
import { ParentGuardiansList } from "./ParentGuardiansView";

const ParticipantsView = () => {
	// const { registrationId } = useParams<ViewRegistationPageParams>();
	// const { data: registration, isLoading: isLoadingRegistration } = useRegistrationByIdQuery(Number(registrationId));
	const { programRegistration, isLoading } = useProgramRegistrationState();

	const isSetup = programRegistration != null && programRegistration.Data.Participants.length > 0;
	const useNewDesign = import.meta.env.VITE_NEW_DESIGN === "true";

	return <>
		{useNewDesign && <>
		<Space h={30} />
		<Group justify="space-between" wrap="nowrap">
			<Group gap="xs">
				{/* <IconAdjustmentsHorizontal /> */}
				<Title order={3}>Participants</Title>
			</Group>
			{/* <Button variant="light" size="xs" mt={-15} mb="md"><IconPencil /> Edit</Button> */}
			{programRegistration &&	<ParticipantsListEditor />}
			
		</Group>
		<Divider my="sm" />
		{(isLoading) && <Center h={150} mx="auto">
			<Loader />
		</Center>}
		{!isSetup && programRegistration && <>
			<Center h={100}>
				<Text c="dimmed">Add one or more participants</Text>
			</Center>
		</>}

		<ParticipantsList data={programRegistration?.Data?.Participants ?? []} programRegistration={programRegistration} />
		<Group px="xs" pt={5} gap={0}>
			<IconArrowUp size={16} color="var(--mantine-color-gray-5)" />
			<Text fz="xs" c="dimmed" >Click on a row for more information</Text>
		</Group>		
		</>}
		
		{!useNewDesign && <>
		{/* <Card shadow="lg" mb="sm" radius="lg" bd="1px solid var(--mantine-color-indigo-outline)"> */}
		<Card shadow="lg" withBorder mb="sm">
			
			{/* <Space h="md" /> */}
			<Group justify="space-between" mb="lg" wrap="nowrap">
				<Group gap="xs">
					<IconAdjustmentsHorizontal />
					<Title order={3}>Participants</Title>
				</Group>
				{/* <Button variant="light" size="xs" mt={-15} mb="md"><IconPencil /> Edit</Button> */}
				{programRegistration &&	<ParticipantsListEditor />}
				
			</Group>
			{(isLoading) && <Center h={150} mx="auto">
				<Loader />
			</Center>}
			{!isSetup && programRegistration && <>
				<Center h={100}>
					<Text c="dimmed">Add one or more participants</Text>
				</Center>
			</>}

			<ScrollArea.Autosize type="hover" mah={350}>
			
			{!isLoading && programRegistration?.Data?.Participants.map((participant, index) => {
				let adultParticipant = participant.Type === "adult" ? participant as AdultParticipant : null;
				let childParticipant = participant.Type === "child" ? participant as ChildParticipant : null;
				return <div key={index} style={{ margin: "calc(1rem / 2)" }}>
					<Grid>
						<Grid.Col span={{ base: 3, sm: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Name:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 4 }} py={0}><Text fw="bold">{adultParticipant && adultParticipant.Salutation} {participant.FirstName} {participant.LastName}</Text></Grid.Col>
						<Grid.Col span={{ base: 3, sm: 2 }} py={0}><Text ta="right" c="dimmed" size="sm">Gender:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 3 }} py={0}><Text>{getGender(participant)}</Text></Grid.Col>
					</Grid>
					{participant.Type == "child" && 
					<Grid mb="xs" mt="xs">
						{childParticipant?.Birthdate !== null && <>
						<Grid.Col span={{ base: 3, sm: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">DoB:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 4 }} py={0}><Text>{moment(childParticipant?.Birthdate).format("LL")}</Text></Grid.Col>
						<Grid.Col span={{ base: 3, sm: 2 }} py={0}><Text ta="right" c="dimmed" size="sm">Age:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 3 }} py={0}><Text>{getAge(childParticipant!, programRegistration.DateFrom)}</Text></Grid.Col>
						</>}
						{childParticipant?.AgeOverrideReason !== undefined && childParticipant.AgeOverrideReason !== "" && <>
						<Grid.Col span={{ sm: 3, lg: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Age Override Reason:</Text></Grid.Col>
						<Grid.Col span={{ sm: 9, lg: 9 }} py={0} style={{ alignSelf: 'flex-end' }}><Text>{childParticipant.AgeOverrideReason}</Text></Grid.Col>
						</>}
						{childParticipant?.HealthConcerns !== undefined && childParticipant.HealthConcerns !== "" && <>
						<Grid.Col span={{ sm: 3, lg: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Health Concerns:</Text></Grid.Col>
						<Grid.Col span={{ sm: 9, lg: 9 }} py={0}><Text>{childParticipant.HealthConcerns}</Text></Grid.Col>
						</>}
						{childParticipant?.Allergies !== undefined && childParticipant.Allergies !== "" && <>
						<Grid.Col span={{ sm: 3, lg: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Allergies:</Text></Grid.Col>
						<Grid.Col span={{ sm: 9, lg: 9 }} py={0}><Text>{childParticipant.Allergies}</Text></Grid.Col>
						</>}
						{childParticipant?.SpecialNeeds !== undefined && childParticipant.SpecialNeeds !== "" && <>
						<Grid.Col span={{ sm: 3, lg: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Special Needs:</Text></Grid.Col>
						<Grid.Col span={{ sm: 9, lg: 9 }} py={0}><Text>{childParticipant.SpecialNeeds}</Text></Grid.Col>
						</>}
						{childParticipant?.NeedsSupport !== undefined && <>
						<Grid.Col span={{ sm: 3, lg: 3 }} py={3} mt={10}><Text ta="right" c="dimmed" size="sm">Needs Support:</Text></Grid.Col>
						<Grid.Col span={{ sm: 9, lg: 9 }} py={0} mt={10}><Badge variant="light" color={childParticipant.NeedsSupport === true ? "green" : "gray"}>{childParticipant.NeedsSupport === true ? "One-on-One Support Required": "None required"}</Badge></Grid.Col>
						</>}


						{childParticipant?.ChangeDiaper !== undefined && <>
						<Grid.Col span={{ sm: 3, lg: 3 }} py={3} mt={0}><Text ta="right" c="dimmed" size="sm">Diaper Change:</Text></Grid.Col>
						<Grid.Col span={{ sm: 9, lg: 9 }} py={0} mt={0}><Badge variant="light" color={childParticipant?.ChangeDiaper === true ? "green" : "orange"}>{childParticipant?.ChangeDiaper === true ? "Permitted to change diaper": "Not permitted to change diaper"}</Badge></Grid.Col>
						</>}
					</Grid>
					}
					
					<Divider mb="sm" label="Contact" labelPosition="center" mt="sm" />
					{participant.Type == "adult" &&
					<Grid mb="xs">
						{adultParticipant?.Email && <>
						<Grid.Col span={{ base: 3, sm: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Email:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 9 }} py={0}><Text>{adultParticipant?.Email}</Text></Grid.Col>
						</>}
						{adultParticipant?.HomePhone && <>
						<Grid.Col span={{ base: 3, sm: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Home Phone:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 9 }} py={0}><Text>{adultParticipant?.HomePhone}</Text></Grid.Col>
						</>}
						{adultParticipant?.MobilePhone && <>
						<Grid.Col span={{ base: 3, sm: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Cell Phone:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 9 }} py={0}><Text>{adultParticipant?.MobilePhone}</Text></Grid.Col>
						</>}
					</Grid>}
					<Grid>
						<Grid.Col span={{ base: 3, sm: 3 }} py={0}><Text ta="right" c="dimmed" size="sm">Address:</Text></Grid.Col>
						<Grid.Col span={{ base: 9, sm: 9 }} py={0}><Text>{formatAddress(participant.Address)}</Text></Grid.Col>
					</Grid>
					{index < programRegistration.Data.Participants.length - 1 && <Divider mt="md" mb="xl" size={3} />}
				</div>
			})}

			</ScrollArea.Autosize>
		</Card>
		</>}
	</>
}

export default ParticipantsView


interface ParticipantsListProps {
	programRegistration: ProgramRegistration;
	data: ParticipantBase[];
}

const ParticipantsList = ({ data, programRegistration }: ParticipantsListProps) => {
	let getAdultParticipant = (participant: ParticipantBase) => participant.Type === "adult" ? participant as AdultParticipant : null;
	let getChildParticipant = (participant: ParticipantBase) => participant.Type === "child" ? participant as ChildParticipant : null;

	const columns: DataTableColumn<ParticipantBase>[] = [
		{ 
			accessor: 'FirstName',
			title: 'Name',
			// width: 100,
			textAlign: 'left',
			render: (item) => {
				const adultParticipant = getAdultParticipant(item);
				const childParticipant = getChildParticipant(item);
				const flagged = childParticipant?.HealthConcerns !== undefined && childParticipant.HealthConcerns !== "" ||
					childParticipant?.Allergies !== undefined && childParticipant.Allergies !== "" ||
					childParticipant?.SpecialNeeds !== undefined && childParticipant.SpecialNeeds !== "" ||
					childParticipant?.ChangeDiaper !== undefined && childParticipant.ChangeDiaper === true;
				return <Group gap={0}>
					<Text fw="bold" inherit>{adultParticipant && adultParticipant.Salutation} {item.FirstName} {item.LastName}</Text>
					{flagged && <ThemeIcon variant="transparent" color="orange"><IconAlertTriangleFilled size={16} /></ThemeIcon>}
				</Group>
			}
		},
		{ 
			accessor: 'Gender',
			title: 'Gender',
			noWrap: true,
			// sortable: true,
			render: (item) => {
				return <>{getGender(item)}</>
			},
		},
		{ 
			accessor: 'Age',
			title: 'Age',
			noWrap: true,
			// sortable: true,
			render: (item) => {
				return <>{item.Type == "adult" && "Adult"}{item.Type == "child" && getAge(getChildParticipant(item)!, programRegistration.DateFrom)}</>
			},
		},
		{
			accessor: 'actions',
			title: <></>,
			hidden: true,
			// textAlign: 'right',
			render: (item) => (
				<Group gap={0} justify="center" wrap="nowrap">
					<Menu position="bottom-end" shadow="md" offset={2}>
						<Menu.Target>
							<ActionIcon onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} variant="subtle" size={26}><IconDots size={16} /></ActionIcon>
							{/* <Button onClick={(e) => { e.preventDefault(); e.stopPropagation(); }} size="compact-xs" h={25} variant="subtle">
								<IconDots size={16} />
							</Button> */}
						</Menu.Target>
						<Menu.Dropdown onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
							<Menu.Label>Actions</Menu.Label>
							<Menu.Item leftSection={<IconPencil size={16} />}>Edit</Menu.Item>
							<Menu.Item leftSection={<IconTrash size={16} />}>Remove</Menu.Item>
							{/* <Menu.Item disabled leftSection={<IconCopy size={16} />}>Duplicate</Menu.Item>
							{invoice.Status == InvoiceStatus.Draft &&
							<Menu.Item onClick={() => openDeleteModal(invoice)} color="red" leftSection={<IconX size={16} />}>Delete draft</Menu.Item>
							}
							<Menu.Divider />
							<Menu.Label>Connections</Menu.Label>
							<Menu.Item component={Link} to={`/customers/${invoice.CustomerId}`} leftSection={<IconUser size={16} />}>View customer</Menu.Item> */}
						</Menu.Dropdown>
					</Menu>
				</Group>
			),
		}
	];

	return <>
		{/* {renderEditor} */}
		<CustomDatatable
			idAccessor="Id"
			columns={columns}
			rows={data}
			rowExpansion={{
				content: ({ record }) => {
					const adultParticipant = getAdultParticipant(record);
					const childParticipant = getChildParticipant(record);
					return <>
						<Container bg="var(--mantine-color-gray-light)" p="xs" style={{ borderRadius: 5 }}>
							<Grid>
								{record.Type == "adult" && <>
									<Grid.Col span={{ sm: 6 }}>
										<Text size="xs" fw="bold">Email</Text>
										<Text size="xs">{adultParticipant?.Email}</Text>
										<Space h={10} />
										<Text size="xs" fw="bold">Address</Text>
										<Text size="xs">{formatAddress(adultParticipant?.Address)}</Text>
									</Grid.Col>
									<Grid.Col span={{ sm: 6 }}>
										<Text size="xs" fw="bold">Home Phone</Text>
										<Text size="xs">{adultParticipant?.HomePhone}</Text>
										<Space h={10} />
										<Text size="xs" fw="bold">Mobile Phone</Text>
										<Text size="xs">{adultParticipant?.MobilePhone}</Text>
									</Grid.Col>
								</>}
								{record.Type == "child" && <>
								<Grid.Col span={{ sm: 6 }}>
									<Text size="xs" fw="bold">Date of Birth</Text>
									<Text size="xs">{moment(childParticipant?.Birthdate).format("LL")}</Text>
									<Space h={10} />
									<Text size="xs" fw="bold">Address</Text>
									<Text size="xs">{formatAddress(record.Address)}</Text>

									{childParticipant?.AgeOverrideReason !== undefined && childParticipant.AgeOverrideReason !== "" && <>
										<Space h={10} />
										<Group gap={5}>
											<Text size="xs" fw="bold">Age Override Reason</Text>
											<ThemeIcon variant="transparent" color="orange" size={16}><IconAlertTriangleFilled size={16} /></ThemeIcon>
										</Group>
										<Text size="xs">{childParticipant?.AgeOverrideReason}</Text>
									</>}
									
									{childParticipant?.ChangeDiaper !== undefined && <>
										<Space h={10} />
										<Text size="xs" fw="bold">Change Diaper</Text>
										<Text size="xs">{childParticipant?.ChangeDiaper === true ? "Yes" : "No"}</Text>
									</>}
								</Grid.Col>
								
								<Grid.Col span={{ sm: 6 }}>
									{childParticipant?.HealthConcerns !== undefined && childParticipant.HealthConcerns !== "" && <>
										<Space h={10} />
										<Group gap={5}>
											<Text size="xs" fw="bold">Health Concerns</Text>
											<ThemeIcon variant="transparent" color="orange" size={16}><IconAlertTriangleFilled size={16} /></ThemeIcon>
										</Group>
										<Text size="xs">{childParticipant?.HealthConcerns}</Text>
									</>}
									{childParticipant?.Allergies !== undefined && childParticipant.Allergies !== "" && <>
										<Space h={10} />
										<Group gap={5}>
											<Text size="xs" fw="bold">Allergies</Text>
											<ThemeIcon variant="transparent" color="orange" size={16}><IconAlertTriangleFilled size={16} /></ThemeIcon>
										</Group>
										<Text size="xs">{childParticipant?.Allergies}</Text>
									</>}
									{childParticipant?.SpecialNeeds !== undefined && childParticipant.SpecialNeeds !== "" && <>
										<Space h={10} />
										<Group gap={5}>
											<Text size="xs" fw="bold">Special Needs</Text>
											<ThemeIcon variant="transparent" color="orange" size={16}><IconAlertTriangleFilled size={16} /></ThemeIcon>
										</Group>
										<Text size="xs">{childParticipant?.SpecialNeeds}</Text>
									</>}
								</Grid.Col>
								</>}
							</Grid>

						</Container>
					</>
				}
			}}
			isLoading={false}
			enablePagination={false}
			pinLastColumn={false}
			noRecordsText="No parents/guardians"
			// defaultRowsPerPage={10}
			// enableSorting={false}
			// defaultSortColumn="Created"
			// defaultSortDirection="desc"

			minHeight={50}
			// onRowClick={() => {
				// navigate({ pathname: `/invoices/${invoice.InvoiceId}`});
			// }}
		/>
	</>
}